import React from 'react';
import { View } from 'react-native';
import { CollectionHero } from '../CollectionHero';
import { ActionBar } from '../../actions';
export const DefaultListHeader = ({ collection, containerStyle, filter, setFilter, }) => {
    return (React.createElement(View, null, collection.cover && (React.createElement(CollectionHero, { uri: collection.cover.src, collection: collection, containerStyle: containerStyle },
        React.createElement(ActionBar, { collection: collection, filter: filter, setFilter: setFilter })))));
};
//# sourceMappingURL=DefaultListHeader.js.map